import { useNavigate, useParams } from "react-router-dom";

import ProgressStep from "components/v2/ProgressSteps/ProgressStep";
import { DateTimeFormat, formatDate } from "helpers/dateTimeHelper";
import { ReactComponent as CloseIcon } from "assets/images/iconsV2/x-close.svg";
import { FormattedMessage, useIntl } from "react-intl";
import "./Header.scss";

interface HeaderProps {
  lastAutoSaveDate: Date | null;
  currentStep: number;
}

// TODO: Implement header design
function Header({ lastAutoSaveDate, currentStep }: HeaderProps) {
  const intl = useIntl();
  const navigate = useNavigate();
  const { shipmentId } = useParams();

  const onCrossClick = () => navigate(shipmentId ? `/shipment/${shipmentId}` : "/");

  const steps = [
    intl.formatMessage({ id: "order.selection", defaultMessage: "Order Selection" }),
    intl.formatMessage({ id: "components.molecules.navigation.shipmentDetails", defaultMessage: "Shipment details" }),
    intl.formatMessage({ id: "provider.details", defaultMessage: "Provider details" }),
    intl.formatMessage({ id: "general.review", defaultMessage: "Review" }),
  ];

  return (
    <div className="consolidation-header">
      <div className="consolidation-header__top">
        <div className="step-title text-xs ml-md mr-md">
          <div className="text-placeholder">
            <FormattedMessage id="orderTypeSelection.createQuoteRequest" defaultMessage="Create quote request" />
          </div>
          <div className="text-placeholder">/</div>
          <div className="fg-secondary">
            <FormattedMessage id="orderTypeSelection.ConsolidatedOrders" defaultMessage="Consolidated orders" />
          </div>
        </div>
        <div className="d-flex align-items-center">
          {lastAutoSaveDate && (
            <div className="mr-xl text-xs text-tertiary">
              <FormattedMessage id="general.autoSaved" defaultMessage="Auto saved" />{" "}
              {formatDate(lastAutoSaveDate, DateTimeFormat.shortDateTimeYearFormat)}
            </div>
          )}
          <div className="p-md">
            <CloseIcon width={20} height={20} className="cursor-pointer" onClick={onCrossClick} />
          </div>
        </div>
      </div>
      <div className="consolidation-header__bottom">
        <div className="consolidation-header__bottom__progress-container">
          {steps.map((step, index) => (
            <div
              key={step}
              className={`text-sm font-medium ${currentStep === index + 1 ? "text-brand-secondary" : ""}`}
              style={{ flexGrow: 1, padding: 0, margin: 0 }}
            >
              <ProgressStep title={step} isActive={currentStep === index + 1} isComplete={currentStep > index + 1} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Header;
